import * as RadixTooltip from '@radix-ui/react-tooltip'
import type { ReactElement, ReactNode } from 'react'

interface TooltipChildProps {
  disabled?: boolean
}

export function TooltipProvider({children}: {children: ReactNode}) {
  return <RadixTooltip.Provider delayDuration={320} skipDelayDuration={120}>
    {children}
  </RadixTooltip.Provider>
}

export function Tooltip({content, children}: {content: string; children: ReactElement<TooltipChildProps>}) {
  if (!content) return children
  const trigger = children.props.disabled
    ? <span className="ui-tooltip-disabled-trigger">{children}</span>
    : children
  return <RadixTooltip.Root>
    <RadixTooltip.Trigger asChild>{trigger}</RadixTooltip.Trigger>
    <RadixTooltip.Portal>
      <RadixTooltip.Content className="ui-tooltip" sideOffset={8}>
        {content}
        <RadixTooltip.Arrow className="ui-tooltip-arrow" />
      </RadixTooltip.Content>
    </RadixTooltip.Portal>
  </RadixTooltip.Root>
}
